import { Button } from "@/components/core/buttons/button";
import { Form, FormControl, FormDescription, FormField, FormGroup, FormItem, FormLabel, FormMessage } from "@/components/core/forms/form.tsx";
import { Input } from "@/components/core/forms/input";
import { useModalControl } from "@/components/core/modals/use-modal-controller";
import { counselInfoQueryOptions } from "@/features/case-evaluation/api/queries/counsels-query";
import { type CounselFormSchema, counselFormSchema } from "@/features/case-evaluation/types/counsel";
import { useCaseCounselMutation } from "@/features/case-record/api/queries/case-records-query";
import cityService from "@/features/dashboard/api/services/city-service";
import provinceService from "@/features/dashboard/api/services/province-service";
import regionService from "@/features/dashboard/api/services/region-service";
import userService from "@/features/dashboard/api/services/user-service";
import { queryClient } from "@/query-client";
import { zodResolver } from "@hookform/resolvers/zod";
import { IconAlertCircle } from "@tabler/icons-react";
import { useQuery } from "@tanstack/react-query";
import clsx from "clsx";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import Alert from "../core/alert";
import { Checkbox } from "../core/forms/checkbox";
import { CheckboxGroup } from "../core/forms/checkbox-group";
import Combobox from "../core/forms/combobox";
import TagsInput from "../core/forms/tags-input";

export default function CaseCustomCoCounselModal({
	data,
	emails,
	caseData,
	defendants,
	// onSubmit,
	isEdit,
	isPlaintiffCounsel,
}: {
	data?: CounselFormSchema;
	emails?: (string | undefined)[];
	isEdit?: boolean;
	isPlaintiffCounsel: boolean;
	// onSubmit: (data: CounselFormSchema) => void;
}) {
	const { closeModal } = useModalControl();
	const form = useForm<CounselFormSchema>({
		resolver: zodResolver(counselFormSchema),
		defaultValues: {
			first_name: data?.first_name || "",
			last_name: data?.last_name || "",
			middle_name: data?.middle_name || "",
			email: data?.email || "",
			region_code: data?.region_code || "",
			province_code: data?.province_code || "",
			city_code: data?.city_code || "",
			barangay: data?.barangay || "",
			zipcode: data?.zipcode || "",
			address_1: data?.address_1 || "",
			address_2: data?.address_2 || "",
			defendants: data?.defendants || [],
			advanced_information: data?.advanced_information || false,
			roll_number: "",
		},
	});

	const [debouncedEmail, setDebouncedEmail] = useState("");
	const [isConfirm, setIsConfirm] = useState(false);
	const [emailExists, setEmailExists] = useState(false);
	const email = form.watch("email");
	const firstName = form.watch("first_name");
	const inputDefendants = form.watch("defendants");
	const advanced = form.watch("advanced_information");
	const [userData, setUserData] = useState(null);

	// const updateDebouncedEmail = useCallback(
	// 	debounce(
	// 		(newEmail) => {
	// 			setDebouncedEmail(newEmail);
	// 		},
	// 		500,
	// 		{ trailing: true },
	// 	),
	// 	[],
	// );

	// useEffect(() => {
	// 	updateDebouncedEmail(email);
	// }, [email, updateDebouncedEmail]);

	// useEffect(() => {
	// 	if (debouncedEmail) {
	// 		userService
	// 			.validateEmail(debouncedEmail)
	// 			.then((response) => {
	// 				if (response) {
	// 					const user = response;
	// 					setEmailExists(true);
	// 					setUserData(user);

	// 					for (const key in user) {
	// 						const value = user[key as keyof typeof user];
	// 						form.setValue(key as keyof CounselFormSchema, (value as string) ?? "");
	// 					}
	// 					if (user?.city?.name) {
	// 						form.setValue("city", {
	// 							name: user.city.name,
	// 							code: user.city.code,
	// 						});
	// 					}
	// 					if (user?.province?.name) {
	// 						form.setValue("province", {
	// 							name: user.province.name,
	// 							code: user.province.code,
	// 						});
	// 					}
	// 					if (user?.region?.name) {
	// 						form.setValue("region", {
	// 							name: user.region.name,
	// 							code: user.region.code,
	// 						});
	// 					}
	// 				} else {
	// 					setEmailExists(false);
	// 					const emailValue = form.getValues("email");
	// 					const defendantsValue = form.getValues("defendants");
	// 					form.reset();
	// 					form.setValue("email", emailValue);
	// 					form.setValue("defendants", defendantsValue);
	// 				}
	// 			})
	// 			.catch((_) => {
	// 				setEmailExists(false);
	// 				const emailValue = form.getValues("email");
	// 				const defendantsValue = form.getValues("defendants");
	// 				form.reset();
	// 				form.setValue("email", emailValue);
	// 				form.setValue("defendants", defendantsValue);
	// 			});
	// 	}
	// }, [debouncedEmail, form]);

	const regionCode = form.watch("region_code");
	const provinceCode = form.watch("province_code");
	const rollNumber = form.watch("roll_number");

	const sameEmail = emails?.includes(form.watch("email") || "");
	const addCasesCounselMutation = useCaseCounselMutation();
	const caseId = caseData?.id;

	const {
		data: counselData,
		isFetching,
		refetch,
	} = useQuery({
		...counselInfoQueryOptions(rollNumber),
		enabled: false,
	});

	const handleClick = async () => {
		setIsConfirm(false);

		if (!rollNumber || rollNumber.trim() === "") {
			form.setValue("email", "");
			form.setValue("first_name", "");
			form.setValue("middle_name", "");
			form.setValue("last_name", "");
			form.setValue("suffix", "");
			return;
		}

		const result = await refetch();
		console.log(result, "counsel data result");
		if (result.data) {
			form.setValue("email", result.data.Email || "");
			form.setValue("first_name", result.data.Attorney_GivenName || "");
			form.setValue("middle_name", result.data.Attorney_MiddleInitial || "");
			form.setValue("last_name", result.data.Attorney_Surname || "");
			form.setValue("suffix", result.data.Attorney_Suffix || "");
		} else {
			form.setValue("email", "");
			form.setValue("first_name", "");
			form.setValue("middle_name", "");
			form.setValue("last_name", "");
			form.setValue("suffix", "");
		}
	};

	const onSubmit = async (data: CounselFormSchema) => {
		await addCasesCounselMutation.mutateAsync({
			data,
			isPlaintiffCounsel,
			caseId,
		});
		queryClient.invalidateQueries({ queryKey: ["case_records"] });
		closeModal();
	};

	return (
		<Form {...form}>
			<form className="w-full" onSubmit={form.handleSubmit(onSubmit)}>
				<div className="flex flex-col w-full gap-4">
					<div className="flex flex-col w-full rounded-md border border-border/50">
						<div className="flex flex-col items-center justify-between w-full py-3 px-4">
							{/* {!sameEmail && emailExists && !isEdit && (
								<div className="col-span-12 w-full py-1">
									<Alert type="info" allowClose={false} title="Email Address Already Exists" icon={<IconAlertCircle size={20} stroke={2} />}>
										The system will use the personal information associated with the email address you entered to auto-fill the form fields. If you do not wish
										to use this information, please enter a different email address.
									</Alert>
								</div>
							)}

							{sameEmail && (
								<div className="col-span-12 w-full py-1">
									<Alert type="error" allowClose={false} title="Email Address Already Added as Counsel" icon={<IconAlertCircle size={20} stroke={2} />}>
										This email is already added as counsel.
									</Alert>
								</div>
							)} */}

							<div className="grid grid-cols-12 w-full py-1 gap-x-4 gap-y-3">
								<div className="col-span-12 flex">
									<FormField
										control={form.control}
										name="defendants"
										render={({ field }) => (
											<FormItem>
												<div className="flex flex-col w-full">
													<FormLabel>{!isPlaintiffCounsel ? "Defendant" : "Plaintiff"} </FormLabel>
													<FormDescription />
												</div>
												<FormGroup>
													<TagsInput
														isMulti={true}
														defaultValue={field.value || []}
														onValueChange={(value) => {
															field.onChange(value);
														}}
														loadOptions={async (value: string) => {
															const items = await regionService.list({
																"filter[search]": value,
															});

															return defendants.map((item) => ({
																label: item.full_name,
																value: item.id,
															}));
														}}
													/>
												</FormGroup>
												<FormMessage />
											</FormItem>
										)}
									/>
								</div>

								<div className="col-span-12 flex">
									<span className="mt-2 grid grid-cols-12 gap-3">
										<span className="col-span-6">
											<FormField
												control={form.control}
												name="roll_number"
												render={({ field }) => (
													<FormItem>
														<FormGroup iconPosition="left">
															<Input autoComplete="off" {...field} placeholder="Enter roll number to search counsel" />
														</FormGroup>
														<FormMessage />
													</FormItem>
												)}
											/>
										</span>
										<span className="col-span-6">
											<Button
												type="button"
												onClick={() => {
													handleClick();
												}}
												loading={isFetching}
											>
												Search Counsel
											</Button>
										</span>
									</span>
								</div>

								<div className="col-span-12 flex">
									<FormField
										control={form.control}
										name="email"
										render={({ field }) => (
											<FormItem>
												<FormLabel>Email Address</FormLabel>
												<FormGroup iconPosition="left">
													<Input disabled={true} autoComplete="off" placeholder="Email Address" {...field} />
												</FormGroup>
												<FormMessage />
											</FormItem>
										)}
									/>
								</div>

								<div className="col-span-6 flex">
									<FormField
										control={form.control}
										name="first_name"
										render={({ field }) => (
											<FormItem>
												<FormLabel required>First Name</FormLabel>
												<FormGroup iconPosition="left">
													<Input
														disabled={true}
														autoComplete="off"
														placeholder="First Name"
														{...field}
														onChange={(e) => field.onChange(e.target.value.toUpperCase())}
													/>
												</FormGroup>
												<FormMessage />
											</FormItem>
										)}
									/>
								</div>

								<div className="col-span-6 flex">
									<FormField
										control={form.control}
										name="middle_name"
										render={({ field }) => (
											<FormItem>
												<FormLabel>Middle Name</FormLabel>
												<FormGroup iconPosition="left">
													<Input
														disabled={true}
														autoComplete="off"
														placeholder="Middle Name"
														{...field}
														onChange={(e) => field.onChange(e.target.value.toUpperCase())}
													/>
												</FormGroup>
												<FormMessage />
											</FormItem>
										)}
									/>
								</div>

								<div className="col-span-6 flex">
									<FormField
										control={form.control}
										name="last_name"
										render={({ field }) => (
											<FormItem>
												<FormLabel required>Last Name</FormLabel>
												<FormGroup iconPosition="left">
													<Input
														disabled={true}
														autoComplete="off"
														placeholder="Last Name"
														{...field}
														onChange={(e) => field.onChange(e.target.value.toUpperCase())}
													/>
												</FormGroup>
												<FormMessage />
											</FormItem>
										)}
									/>
								</div>
								<div className="col-span-6 flex">
									<FormField
										control={form.control}
										name="suffix"
										render={({ field }) => (
											<FormItem>
												<FormLabel required>Suffix</FormLabel>
												<FormGroup iconPosition="left">
													<Input
														disabled={true}
														autoComplete="off"
														placeholder="Suffix"
														{...field}
														onChange={(e) => field.onChange(e.target.value.toUpperCase())}
													/>
												</FormGroup>
												<FormMessage />
											</FormItem>
										)}
									/>
								</div>

								<div className="col-span-12 flex">
									<Alert type="info" allowClose={false} title="Confirm Add Counsel" icon={<IconAlertCircle size={20} stroke={2} />} className="w-full">
										<CheckboxGroup>
											<FormItem>
												<FormGroup>
													<div className="flex flex-row w-full gap-2">
														<FormControl>
															<Checkbox
																checked={isConfirm}
																disabled={!firstName}
																onCheckedChange={(checked) => {
																	setIsConfirm(checked);
																}}
															/>
														</FormControl>
														<FormLabel>
															<div className="flex flex-col w-full">
																<span className="text-base text-foreground">
																	I understand all details of this action is correct and confirm that I want to add this counsel.
																</span>
															</div>
														</FormLabel>
													</div>
												</FormGroup>
												<FormMessage />
											</FormItem>
										</CheckboxGroup>
									</Alert>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="flex flex-row justify-between w-full pt-4">
					<Button
						className=""
						variant="ghost"
						type="button"
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</Button>
					<Button disabled={!isConfirm || inputDefendants.length === 0} className="" loading={form.formState.isSubmitting}>
						Confirm
					</Button>
				</div>
			</form>
		</Form>
	);
}
